module.exports = __webpack_public_path__ + "expanded.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/expanded.svg?color1=%23333333&color2=
// module id = 2196
// module chunks = 67